import { Injectable } from '@angular/core';
import { ChatMessageAdapter } from '@app/model/chat-message-adapter.model';
import { ChatMessageModel } from '@app/model/chat-message.model';
import { ChatMessageType, ProfileService } from 'library-explorer';
import { AppSyncChatMessage } from '@app/services/chat.service';

interface AppSyncLocalMessage extends AppSyncChatMessage {
  loading?: boolean;
}

@Injectable()
export class AppSyncChatAdapter implements ChatMessageAdapter {

  constructor(private readonly profileService: ProfileService) {}

  public mapMessage(raw: AppSyncLocalMessage): ChatMessageModel {
    const currentUser = this.profileService.getCurrentProfileValue();
    const isCurrentUser = raw.senderId === currentUser?.id;

    return {
      id: raw.messageId,
      message: raw.content,
      timestamp: raw.createdAt ? new Date(raw.createdAt) : new Date(),
      sender: isCurrentUser
        ? {
            id: currentUser.id,
            name: currentUser.name,
            lastName: currentUser.lastName,
            avatarUrl: currentUser.avatarUrl,
            mediaImage: currentUser.mediaImage,
          }
        : {
            id: raw.senderId,
            name: raw.senderId,
          },
      type: raw.loading ? ChatMessageType.LOADING_MESSAGE : ChatMessageType.TEXT_MESSAGE,
    };
  }

  public newMessage(data: { message?: string, currentUser?: boolean, timestamp?: Date, loading?: boolean }): AppSyncLocalMessage {
    const currentUser = this.profileService.getCurrentProfileValue();
    return {
      messageId: `local_${Date.now()}`,
      channelUrl: '',
      senderId: data.currentUser ? (currentUser?.id ?? '') : '',
      content: data.message ?? '',
      createdAt: (data.timestamp ?? new Date()).toISOString(),
      loading: data.loading,
    };
  }

  public shouldLoadMessages(): boolean {
    return false;
  }
}
